import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { StyledNavbarUserInfo } from "../styled/styles";
import { logoutUser } from "../../_actions/authActions";
import { withRouter } from "react-router-dom";
import { MY_ACCOUNT } from "../../_utils/routes";
import { TldrUserInfoView } from "./statelessView";
import { isFreePlan } from "../../_utils/isFreePlan";
import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaCrown, FaUserCircle } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import TldrTrialEndedModal from "../../TldrSettings/TldrBillingAndPayments/Modals/TldrTrialEndedModal";
import { analyticsTrackEvent, isWorkspaceOwner } from "../../_utils/common";

const itemStyles = {
  color: "gray.300",
  _hover: {
    bg: "none",
    color: "primary.200",
  },
};
const dividerStyles = {
  borderWidth: "1px",
  borderColor: "brand.border-color",
  my: 2,
  width: "initial",
};
const userDetailStyles = {
  color: "gray.100",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export class TldrNavDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpgradePlanModal: false,
    };
    this.onLogoutClick = this.onLogoutClick.bind(this);
  }

  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logoutUser();
  };

  render() {
    const { t } = this.props;
    const { user } = this.props.auth.payload;
    const { email, full_name, profile_picture, username } = user;
    const isFree = isFreePlan(this.props.subscription.subscribedPlan);
    const isOwner = isWorkspaceOwner(this.props.auth.payload.user);

    return (
      <>
        <Flex alignItems="center">
          <Menu isLazy autoSelect={false}>
            <MenuButton
              as={Button}
              rounded="full"
              variant="link"
              cursor="pointer"
              minW={0}
            >
              <TldrUserInfoView user={user}></TldrUserInfoView>
            </MenuButton>
            <Portal>
              <MenuList zIndex={1005}>
                <MenuItem sx={itemStyles}>
                  <Tooltip hasArrow label={full_name ? full_name : username}>
                    <StyledNavbarUserInfo>
                      <Box
                        maxW="62px"
                        maxH="62px"
                        borderRadius="full"
                        display={["block", "block", "none"]}
                      >
                        {profile_picture ? (
                          <Image
                            src={profile_picture}
                            alt="profile"
                            style={{
                              borderRadius: "100%",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        ) : (
                          <FaUserCircle />
                        )}
                      </Box>
                      <Box ml="0.25rem">
                        <Text sx={userDetailStyles} fontSize="0.75rem">
                          {full_name ? full_name : username}
                        </Text>
                        <Text sx={userDetailStyles} fontSize="0.87rem">
                          {email}
                        </Text>
                      </Box>
                    </StyledNavbarUserInfo>
                  </Tooltip>
                </MenuItem>
                <Divider sx={dividerStyles} />
                <MenuItem
                  onClick={() => this.props.history.push(MY_ACCOUNT)}
                  sx={itemStyles}
                >
                  {t("manage_account")}
                </MenuItem>
                {isOwner && isFree && (
                  <>
                    <Divider sx={dividerStyles} />
                    <MenuItem
                      sx={itemStyles}
                      onClick={() => {
                        analyticsTrackEvent("upgradePlan");
                        this.setState({ showUpgradePlanModal: true });
                      }}
                    >
                      <Icon color="brand.primary" as={FaCrown} mr={2} />
                      {t("upgrade_btn")}
                    </MenuItem>
                  </>
                )}
                <Divider sx={dividerStyles} />
                <MenuItem onClick={this.onLogoutClick} sx={itemStyles}>
                  {t("logout")}
                </MenuItem>
              </MenuList>
            </Portal>
          </Menu>
        </Flex>
        {this.state.showUpgradePlanModal ? (
          <TldrTrialEndedModal
            show={this.state.showUpgradePlanModal}
            onHide={() => this.setState({ showUpgradePlanModal: false })}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state.subscription,
});

TldrNavDropdown.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser()),
});

export default withTranslation(["navbar"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrNavDropdown))
);
